import { useEffect, useRef, useState } from "react";

const Loader = ({ top = null, left = null }) => {
  const [customStyle, setCustomStyle] = useState({});
  const ref = useRef();

  useEffect(() => {
    if (ref.current) {
      const resizeObserver = new ResizeObserver((entries) => {
        if (entries.length) {
          const { width, height } = entries[0].target.getBoundingClientRect();
          setCustomStyle({
            ...(left ? { width: `${width - left}px` } : {}),
            ...(top ? { height: `${height - top}px` } : {}),
          });
          ref.current && resizeObserver.unobserve(ref.current);
          resizeObserver.disconnect();
        }
      });

      resizeObserver.observe(ref.current);
    }
  }, [top, left]);

  return (
    <>
      <div
        className="w-full h-full absolute  opacity-30 bg-white flex justify-center items-center z-50 overflow-hidden"
        style={{ top: top || 0, left: left || 0, ...customStyle }}
        ref={ref}
      ></div>
      <i className="fa-solid fa-spin fa-spinner text-primary text-4xl absolute top-1/2 left-1/2 z-50"></i>
    </>
  );
};

export default Loader;
